import { MESSAGE_CREATE_PENDING, CLEAR_PENDING_MESSAGES } from 'app/modules/messages/constants';

export const pending = (state = [], action) => {
  switch (action.type) {
    case MESSAGE_CREATE_PENDING:
      return [...state, action.record];
    case CLEAR_PENDING_MESSAGES:
      return [];
    default:
      return state;
  }
};

export default pending;

/*
 * Action creators
 */
export const createMessagePending = record => ({ type: MESSAGE_CREATE_PENDING, record });
export const clearPendingMessages = () => ({ type: CLEAR_PENDING_MESSAGES });
